import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';

import '@effectivastudio/lit-components/components/icon/element.js';
import '@effectivastudio/lit-components/components/badge/element.js';
import '@effectivastudio/lit-components/components/grid_list/element.js';
import '../button_more/element.js';
import '../profile_avatar/element.js';

import style from './style.lit.css';

/**
 * Component used as page header.
 *
 * @prop backUrl - Fallback url in case there is no history
 *
 * @slot left - For back or profile link
 * @slot default - For title, avatar or logo
 * @slot right - For notifications
 */

export default class Header extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    chats: { type: Number },
    notifications: { type: Number },
    backUrl: { type: String },
    theme: { type: String },
  };

  renderProfileLink() {
    return html`
      <a href="#profile">
        <ef-icon name="circle-user"></ef-icon>
      </a>
    `;
  }

  renderBackLink() {
    return html`
      <a href=${this.backUrl}>
        <ef-icon name="chevron-left"></ef-icon>
      </a>
    `;
  }

  render() {
    return html`
      <aside>
        <slot name="left">
          ${this.backUrl ? this.renderBackLink() : this.renderProfileLink()}
        </slot>
      </aside>

      <main>
        <slot>Crossiety</slot>
      </main>

      <aside>
        <slot name="right">
          <a href="#chat">
            <ef-icon
              name="message-lines"
              badgeCount=${ifDefined(this.chats)}></ef-icon>
          </a>
          <a href="#bell">
            <ef-icon
              name="bell"
              badgeCount=${ifDefined(this.notifications)}></ef-icon>
          </a>
        </slot>
      </aside>
    `;
  }
}

customElements.get('xs-header') || customElements.define('xs-header', Header);
